import { Tabs, Tab } from '@mui/material'
import { FormSection, Grid } from '../../../../UniversalComponents'
import { useReducer } from 'react'

const BoatConfigInsightsTelemetry = ({ boatInsights, telemetry }) => {
    const tabProps = (index: number, category: string) => {
        return {
            id: `tab-${category}-${index}`,
            key: `tab-${category}-${index}`,
            'aria-controls': `tabpanel-${category}-${index}`,
        }
    }

    const defaultState = {
        boatInsightCategory: 0,
        boatInsightCategories:
            boatInsights && boatInsights?.length !== 0
                ? boatInsights?.map(({ category }, index) => (
                      <Tab
                          label={category}
                          iconPosition="start"
                          {...tabProps(index, category)}
                      />
                  ))
                : [],
    }
    const reducer = (state, newState) => ({ ...state, ...newState })
    const [state, setState] = useReducer(reducer, defaultState)

    const { boatInsightCategory, boatInsightCategories } = state
    const setCurrentTab = (event: React.SyntheticEvent, newValue: number) => {
        setState({
            boatInsightCategory: newValue,
        })
    }
    return (
        <Grid item xs={12}>
            <Grid container spacing={2}>
                <FormSection
                    title="Boat Insight Telemetry"
                    titleAlignment="left"
                >
                    <Grid item xs={12}>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sx={{ marginBottom: 5 }}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} md={8}>
                                        <Tabs
                                            value={boatInsightCategory}
                                            onChange={setCurrentTab}
                                            aria-label="Category Tabs"
                                        >
                                            {boatInsightCategories}
                                        </Tabs>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={12}>
                                <Grid
                                    container
                                    spacing={2}
                                    sx={{ marginLeft: -1 }}
                                >
                                    {boatInsights?.map((boatInsight, index) => {
                                        if (index !== boatInsightCategory)
                                            return null

                                        return boatInsight.rawSignals.map(
                                            (signal, rawSignalIndex) => {
                                                const latestValue =
                                                    telemetry[signal.signalName]
                                                        ?.latest_value ??
                                                    'No Value'
                                                const timestamp =
                                                    telemetry[signal.signalName]
                                                        ?.latest_timestamp ??
                                                    '—'

                                                return (
                                                    <div
                                                        key={`signal-${signal.signalName}-${rawSignalIndex}`}
                                                        style={{
                                                            backgroundColor:
                                                                '#2b2b2b',
                                                            borderRadius:
                                                                '12px',
                                                            padding:
                                                                '16px 20px',
                                                            margin: '10px 0',
                                                            minWidth: '200px',
                                                            maxWidth: '280px',
                                                            width: '100%',
                                                            boxShadow:
                                                                '0 4px 12px rgba(0, 0, 0, 0.5)',
                                                            display: 'flex',
                                                            flexDirection:
                                                                'column',
                                                            justifyContent:
                                                                'center',
                                                            color: '#fff',
                                                            fontFamily:
                                                                'Inter, sans-serif',
                                                            transition:
                                                                'all 0.25s ease',
                                                            cursor: 'default',
                                                            overflow: 'hidden',
                                                        }}
                                                        onMouseEnter={(e) => {
                                                            e.currentTarget.style.transform =
                                                                'translateY(-4px)'
                                                            e.currentTarget.style.boxShadow =
                                                                '0 12px 20px rgba(0,0,0,0.7)'
                                                        }}
                                                        onMouseLeave={(e) => {
                                                            e.currentTarget.style.transform =
                                                                'translateY(0)'
                                                            e.currentTarget.style.boxShadow =
                                                                '0 4px 12px rgba(0,0,0,0.5)'
                                                        }}
                                                    >
                                                        <div
                                                            style={{
                                                                fontSize:
                                                                    '13px',
                                                                opacity: 0.8,
                                                                marginBottom:
                                                                    '6px',
                                                                wordBreak:
                                                                    'break-word',
                                                                hyphens: 'auto',
                                                                lineHeight:
                                                                    '1.3',
                                                                maxWidth:
                                                                    '100%',
                                                            }}
                                                        >
                                                            {signal.signalName}
                                                        </div>

                                                        <div
                                                            style={{
                                                                fontSize:
                                                                    '20px',
                                                                fontWeight: 700,
                                                                color:
                                                                    latestValue !==
                                                                    'No Value'
                                                                        ? '#4caf50'
                                                                        : '#ff3b30',
                                                                margin: '4px 0',
                                                                wordBreak:
                                                                    'break-all',
                                                                lineHeight:
                                                                    '1.1',
                                                                letterSpacing:
                                                                    '0.5px',
                                                            }}
                                                        >
                                                            {latestValue}
                                                            {signal.unit && (
                                                                <span
                                                                    style={{
                                                                        fontSize:
                                                                            '16px',
                                                                        fontWeight: 500,
                                                                        opacity: 0.7,
                                                                        marginLeft:
                                                                            '4px',
                                                                    }}
                                                                >
                                                                    {
                                                                        signal.unit
                                                                    }
                                                                </span>
                                                            )}
                                                        </div>

                                                        <div
                                                            style={{
                                                                fontSize:
                                                                    '12px',
                                                                color: '#888',
                                                                marginTop:
                                                                    '8px',
                                                                opacity: 0.7,
                                                                fontStyle:
                                                                    'italic',
                                                            }}
                                                        >
                                                            {timestamp !== '—'
                                                                ? new Date(
                                                                      timestamp
                                                                  )?.toLocaleString(
                                                                      'en-US',
                                                                      {
                                                                          weekday:
                                                                              'short',
                                                                          year: 'numeric',
                                                                          month: 'short',
                                                                          day: 'numeric',
                                                                          hour: 'numeric',
                                                                          minute: '2-digit',
                                                                      }
                                                                  )
                                                                : '—'}
                                                        </div>
                                                    </div>
                                                )
                                            }
                                        )
                                    })}
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </FormSection>
            </Grid>
        </Grid>
    )
}

export default BoatConfigInsightsTelemetry
